import { getSubjectToken } from "./fabricAuth";

export type RejectionReason =
  | "Strict Corporate Policy"
  | "Too Costly"
  | "Technical Constraint"
  | "Already Planned";

export interface RejectPayload {
  featureId: string;
  reason: RejectionReason;
  workspaceId: string;
  lakehouseId: string;
}

export interface Proposal {
  featureId: string;
  title: string;
  summary: string;
  category: "Security" | "Cost" | "Performance" | "Governance";
  source: "tenant-setting" | "workspace-gap" | "workspace-governance";
  evidence: string | null;
  workspaceId: string | null;
  workspaceName: string | null;
}

export interface RecommendationsResponse {
  mode: "admin" | "user";
  proposals: Proposal[];
}

export async function fetchRecommendations(): Promise<RecommendationsResponse> {
  const token = await getSubjectToken();
  const res = await fetch("/api/recommendations", {
    cache: "no-store",
    headers: { Authorization: `Bearer ${token}` }
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Recommendations failed (${res.status}): ${text.substring(0, 500)}`);
  }
  const raw = await res.json();
  const proposals = (raw.proposals ?? raw.Proposals ?? []).map((p: any) => ({
    featureId: p.featureId ?? p.FeatureId,
    title: p.title ?? p.Title,
    summary: p.summary ?? p.Summary,
    category: p.category ?? p.Category ?? "Governance",
    source: p.source ?? p.Source,
    evidence: p.evidence ?? p.Evidence ?? null,
    workspaceId: p.workspaceId ?? p.WorkspaceId ?? null,
    workspaceName: p.workspaceName ?? p.WorkspaceName ?? null
  }));
  return { mode: raw.mode ?? raw.Mode, proposals };
}

export async function rejectRecommendation(p: RejectPayload): Promise<void> {
  const token = await getSubjectToken();
  const res = await fetch("/api/reject", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      FeatureId: p.featureId,
      Reason: p.reason,
      WorkspaceId: p.workspaceId,
      LakehouseId: p.lakehouseId
    })
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Reject failed (${res.status}): ${text}`);
  }
}
